import splitOnMatch from '../../helpers/table/splitOnMatch'

/**
 * De uitlegregel onder een huishouden dat als zoekresultaat overbleef.
 *
 * Het overzicht zoekt door alle gegevens van het tabblad 'Gegevens', dus een
 * huishouden kan er staan om iets wat nergens op het scherm te zien is. Zonder
 * deze regel leest zo'n rij als een fout.
 *
 * Van vrije tekst uit het dossier (en van velden die een organisatie zelf heeft
 * bedacht) verschijnt alleen de veldnaam — de inhoud van een coachverslag hoort
 * niet in een lijstoverzicht.
 * AI-CONTEXT: See docs/features/huishouden-zoeken-alle-gegevens.md
 *
 * @param {object} props
 * @param {{title: string, value: string, showValue: boolean} | null} props.hit - Uitkomst van findHouseholdSearchHit
 * @param {string} props.searchTerm - Waar de gebruiker op zocht
 */
const HouseholdSearchHit = ({ hit, searchTerm }) => {
    if (!hit) return null

    if (!hit.showValue) {
        return <p className="household-search-hit">{`Gevonden in ${hit.title}`}</p>
    }

    return (
        <p className="household-search-hit">
            <span className="household-search-hit__field">{hit.title}</span>
            {' · '}
            {splitOnMatch(hit.value, searchTerm).map((part, index) => (
                part.hit
                    ? <span className="household-search-hit__match" key={index}>{part.text}</span>
                    : <span key={index}>{part.text}</span>
            ))}
        </p>
    )
}

export default HouseholdSearchHit
